var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"required-block"},[_c('CustomCheckBox',{attrs:{"active":_vm.item.check.requiredOne,"name":_vm.prefixInput+'req',"label":"One account is required"},on:{"check":_vm.clickCheck}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }